module.exports = __webpack_public_path__ + "static/media/btnPrev.7500cdac.svg";